module.exports = __webpack_public_path__ + "static/media/3DPPA41.f55999b8.jpg";